import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendario-institucional',
  templateUrl: './calendario-institucional.component.html',
  styleUrls: ['./calendario-institucional.component.scss'],
  providers: [DatePipe]
})
export class CalendarioInstitucionalComponent implements OnInit {

  tituloPantalla = "CALENDARIO INSTITUCIONAL";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
